<div class="login login-container">
  <div class="bg" *ngIf="domainType !== 'ai-imagery'">
    <div class="login-bg-backdrop">
      <img
        src="https://cdn.catexpert.ab-inbev.com/assets/images/catman-logo-white-black.png"
        class="login-banner-logo"
      />
    </div>
  </div>

  <div class="bg bg-ai-imagery" *ngIf="domainType === 'ai-imagery'"></div>

  <div class="login-section">
    <form>
      <div [ngClass]="this.domainType === 'pho' ? 'login-logo logo-pho' : ''">
        <img
          *ngIf="domainType !== 'ai-imagery'"
          src="https://cdn.catexpert.ab-inbev.com/assets/images/login-logo.png"
          class="login-logo"
        />

        <img
          *ngIf="domainType === 'ai-imagery'"
          src="https://cdn.catexpert.ab-inbev.com/assets/images/logo-ai-imagery-login.svg"
          class="header-logo-lg mb-10"
          style="height: 50px"
        />
      </div>

      <div>
        <label *ngIf="signUp" class="login-head">{{ 'LOGIN.USER_ON_BOARDING' | translate }}</label>
      </div>
      <ng-container *ngIf="!signUp">
        <div>
          <button class="btn btn-primary login-btn" (click)="login()">
            <span class="login-btn-text">{{ 'LOGIN.LOGIN_WITH_ABINBEV' | translate }}</span>
            <img
              class="collection-forward"
              src="https://cdn.catexpert.ab-inbev.com/assets/images/white-arrow.svg"
            />
          </button>
        </div>
        <div *ngIf="domainType !== 'ai-imagery'">
          <label class="form-check-label my-4"
            >{{ 'LOGIN.DONT_HAVE_ACCOUNT' | translate }}
            <a href="/home#onboarding" class="login-sign-up"
              >{{ 'LOGIN.RAISE_ONBOARDING_REQUEST' | translate }}
            </a></label
          >
        </div>
      </ng-container>
    </form>
  </div>
</div>
